import { render } from "./LocalizedCKEditor.vue?vue&type=template&id=55edd09e"
import script from "./LocalizedCKEditor.vue?vue&type=script&lang=js"
export * from "./LocalizedCKEditor.vue?vue&type=script&lang=js"

import "./LocalizedCKEditor.vue?vue&type=style&index=0&id=55edd09e&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__